<template>
  <div class="historial-resumen">
    <b-card>
      <div class="tabla-wrapper">
        <table class="tabla-resumen">
          <thead>
            <tr>
              <th class="sticky-col">Categoria</th>
              <th class="sticky-col">Equipo</th>
              <th>Total</th>
              <th v-for="dia in diasSemana" :key="dia">
                {{ formatearDia(dia) }}
              </th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="equipo in resumen" :key="equipo.id_equipo">
              <td class="sticky-col nombre-equipo">
                {{ equipo.categoria }}
              </td>
              <td class="sticky-col nombre-equipo">
                {{ equipo.nombre_equipo }}
              </td>

              <td class="total">
                {{ equipo.total_partidos }}
              </td>

              <td
                v-for="dia in diasSemana"
                :key="dia"
                :style="getColor(equipo[dia])"
              >
                {{ equipo[dia] || 0 }}
              </td>
            </tr>

            <tr v-if="!resumen || resumen.length === 0">
              <td colspan="9" class="empty">
                No hay datos disponibles
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-card>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import {
  // BTabs,
  // BTab,
  BCard,
  // VBTooltip,
  // BOverlay,
  //   xx,
  //   xx,
  //   xx,
  //   xx,
  //   xx,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    // BTabs,
    // BTab,
    // VBTooltip,
    // BOverlay,
  },
  directives: {
    Ripple,
    // 'b-tooltip': VBTooltip,
  },
  props: {
    resumen: {
      type: Array,
      default: () => [],
    },
  },

  setup(props) {
    const diasSemana = [
      'lunes',
      'martes',
      'miercoles',
      'jueves',
      'viernes',
      'sabado',
      'domingo',
    ]

    const formatearDia = dia => dia.charAt(0).toUpperCase() + dia.slice(1)
    const maxValor = computed(() => {
      if (!props.resumen?.length) return 1

      return Math.max(
        ...props.resumen.flatMap(
          equipo => diasSemana.map(dia => Number(equipo[dia]) || 0),
          // eslint-disable-next-line
        ),
      )
    })
    const getColor = valor => {
      const v = Number(valor) || 0

      if (v === 0) return 'background-color: #f5f5f5'

      const ratio = v / maxValor.value // entre 0 y 1

      // verde → más fuerte mientras más alto
      const lightness = 90 - ratio * 50 // 90% → 40%
      const color = `hsl(120, 60%, ${lightness}%)`

      return `background-color: ${color}; color: ${
        ratio > 0.6 ? 'white' : 'black'
      }`
    }

    return {
      diasSemana,
      formatearDia,
      getColor,
    }
  },
}
</script>

<style scoped>
.historial-resumen {
  margin: 10px;
  font-family: Arial, sans-serif;
}

.tabla-wrapper {
  height: calc(100vh - 300px); /* ajusta ese 200 */
  overflow: auto;
  border: 1px solid #ddd;
  border-radius: 10px;
}

.tabla-resumen {
  width: 100%;
  border-collapse: collapse;
  min-width: 800px;
}

.tabla-resumen th,
.tabla-resumen td {
  padding: 10px;
  text-align: center;
  border-bottom: 1px solid #eee;
}

/* HEADER STICKY */
.tabla-resumen thead th {
  position: sticky;
  top: 0;
  background: #ffffff;
  z-index: 3;
  font-weight: bold;
}

/* COLUMNA EQUIPO STICKY */
.sticky-col {
  position: sticky;
  left: 0;
  background: #fff;
  z-index: 2;
  text-align: left;
}

/* estilos */
.nombre-equipo {
  font-weight: 600;
  font-size: 12px;
}

.total {
  font-weight: bold;
  background: #fafafa;
}

/* HEATMAP */
.bg-0 {
  background-color: #f5f5f5;
}

.bg-1 {
  background-color: #d0f0d0;
}

.bg-2 {
  background-color: #9be79b;
}

.bg-3 {
  background-color: #4cd964;
  color: white;
}

.bg-4 {
  background-color: #1e7e34;
  color: white;
}

/* hover bonito */
.celda:hover {
  transform: scale(1.1);
  transition: 0.2s;
  cursor: pointer;
}

/* empty */
.empty {
  padding: 20px;
  text-align: center;
  color: #999;
}
</style>
